import { render, staticRenderFns } from "./countryselect.vue?vue&type=template&id=0ff395e1&scoped=true&"
import script from "./countryselect.vue?vue&type=script&lang=js&"
export * from "./countryselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff395e1",
  null
  
)

export default component.exports